'use strict';

import VZTcBaseCard from './VZTcBaseCard';
import { tryParseJSON } from 'app_vodafone_ziggo/util/util';

export default class VZTcPortingNumberType extends VZTcBaseCard {
    constructor() {
        super();

        this.boundHandleRadioChange = this.handleRadioChange.bind(this);
    }

    connectedCallback() {
        super.initializeCard();
        this.addEventListeners();
        this.setRadioButton();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }

    addEventListeners() {
        this.numberTypeToggle?.addEventListener('change', this.boundHandleRadioChange);
    }

    removeEventListeners() {
        this.numberTypeToggle?.removeEventListener('change', this.boundHandleRadioChange);
    }

    get numberTypeToggle() {
        return this.querySelector('.js-number-type-toggle');
    }

    handleRadioChange({ target: radio }) {
        // Select porting addon when bundle is selected
        // Porting and number bundle share the same number type
        this.constructor.setPortingAddon(radio);

        this.updateConfig('product', this.questionId, {
            pid: radio.getAttribute('data-product-id'),
            qty: radio.getAttribute('data-product-qty'),
            variation: radio.getAttribute('data-product-size')
        });
    }

    /**
     * Sets the default radio button selection for porting number type if none is selected
     * - Checks if the cart's porting value is not 0
     * - If no radio button is selected for porting-choose-number-type, selects the regional option by default
     * - Triggers the radio change handler after selection
     */
    setRadioButton() {
        const cartValues = document.querySelector('.js-add-to-cart-values') ?? null;
        if (cartValues?.dataset.porting !== '0') {
            const checkedRadios = document.querySelectorAll('input[name="porting-choose-number-type"]:checked');
            if (checkedRadios.length === 0) {
                const regionalRadio = document.querySelector('input[name="porting-choose-number-type"][data-product-id*="regional"]');
                if (regionalRadio) {
                    regionalRadio.checked = true;

                    this.handleRadioChange({ target: regionalRadio });
                }
            }
        }
    }

    // Adds a porting addon and its quantity to the cart dataset.
    static setPortingAddon(el) {
        // Porting bundle and qty are taken from the porting input
        const { portingBundle, portingQty } = el.dataset;
        const qty = parseInt(portingQty, 10);

        if (!portingBundle || !portingQty || qty <= 0) return;

        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (!addToCartValues) return;

        const addons = tryParseJSON(addToCartValues.dataset.addons, []);
        const addonsQty = tryParseJSON(addToCartValues.dataset.addonsQty, []);

        const updatedAddons = [];
        const updatedAddonsQty = [];

        // Removes old porting addon
        addons.forEach((item, index) => {
            if (!item.includes('portin')) {
                updatedAddons.push(item);
                updatedAddonsQty.push(addonsQty[index]);
            }
        });

        // Add new porting bundle
        updatedAddons.push(portingBundle);
        updatedAddonsQty.push(qty);

        // Save on the element
        addToCartValues.dataset.addons = JSON.stringify(updatedAddons);
        addToCartValues.dataset.addonsQty = JSON.stringify(updatedAddonsQty);
    }
}

if (!window.customElements.get('vz-tc-porting-number-type')) {
    window.customElements.define('vz-tc-porting-number-type', VZTcPortingNumberType);
}
